/* eslint-disable indent */
import type { FC } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';

import { Button } from '@pulse-web-ui/button';

import { Container, FormSub, FormSubLabel } from '@src/components';
import { sendUserIdToAnalytics } from '@src/components/web-analytic/utils';
import { useIsDesktop } from '@src/hooks';
import { handleAnalyticsEvents, useScrollToIframeOnMount } from '@src/utils';

import { BaseLayout } from '../../layouts/base-layout';
import { PayTitle } from './best-to-pay-page.styles';
import { useHandleGoBack } from './hooks';

export const BestToPayErrorPage: FC = () => {
  const { t } = useTranslation();
  useHandleGoBack('error');

  const currentSelectedProduct = localStorage.getItem('selectedProduct');
  const preset = localStorage.getItem('preset');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    if (userId) {
      sendUserIdToAnalytics(userId);
    }
  }, [userId]);

  const retryHandler = () => {
    localStorage.setItem('retryPayment', uuid());
    localStorage.removeItem('paymentDecline');
  };

  useScrollToIframeOnMount();

  useEffect(() => {
    handleAnalyticsEvents.handleDeclinePaymentAnalyticsEvents({
      selectedProduct: currentSelectedProduct,
      preset,
    });
  }, []);

  useEffect(() => {
    localStorage.setItem('paymentDecline', '1');
  }, []);

  const isDesktop = useIsDesktop();

  return (
    <BaseLayout>
      <Container>
        <PayTitle>{t('BEST_TO_PAY:headers.paymentDeclined')}</PayTitle>
        <FormSubLabel>
          {t('BEST_TO_PAY:hints.technicalReasonsPaymentDeclined')}
        </FormSubLabel>
        <FormSub>
          <Button
            onClick={retryHandler}
            variant="primary"
            label={t('COMMON:buttons.tryAgain') || ''}
            adaptiveWidth={!isDesktop}
          />
        </FormSub>
      </Container>
    </BaseLayout>
  );
};
